import { FormattedMessage } from 'react-intl';

import { Gallery } from '@sorare/core/src/atoms/icons/Gallery';
import { BodyM } from '@sorare/core/src/atoms/typography';
import { Switch } from '@sorare/core/src/components/search/Switch';
import { useVirtualToggle } from '@sorare/core/src/hooks/useVirtualToggle';
import { useVirtualToggleManager } from '@sorare/core/src/hooks/useVirtualToggleManager';
import type { FilterWidget } from '@sorare/core/src/lib/filters';
import { VIRTUAL_TOGGLE_FILTERS } from '@sorare/core/src/lib/filters';

import { Toggle } from '#src/searchCards/Toggle/index.tsx';

const DUPLICATE_FILTER = VIRTUAL_TOGGLE_FILTERS.duplicateFilter;

const DuplicateFilterComponent = () => {
  const setVirtualToggle = useVirtualToggleManager();
  const { currentRefinement } = useVirtualToggle<string>({
    name: DUPLICATE_FILTER.name,
  });
  return (
    <Toggle icon={<Gallery />}>
      <Switch
        checked={!!currentRefinement}
        onChange={event => {
          setVirtualToggle({
            [DUPLICATE_FILTER.name]: event.target.checked
              ? 'player.slug'
              : false,
          });
        }}
        label={
          <BodyM bold>
            <FormattedMessage {...DUPLICATE_FILTER.label} />
          </BodyM>
        }
      />
    </Toggle>
  );
};

export const DuplicateFilter: FilterWidget = {
  key: 'duplicatedKey',
  type: 'toggle',
  attribute: '',
  Component: DuplicateFilterComponent,
};
